module.exports = "#logincontainer .aaae-label-fp {\n  margin: 0 auto;\n  margin-bottom: 20px; }\n\n#logincontainer .registerLink {\n  margin: 25px 0 15px 0;\n  text-align: center; }\n\n#logincontainer .colaLogo {\n  width: 240px;\n  height: 95px; }\n\n#logincontainer .btnlogin {\n  background: #052e47;\n  border: #052e47;\n  color: #ffffff; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = ./src/app/login/login.component.scss
// module chunks = main